import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { RequestForm } from "@/lib/types";

/**
 * Ideenbox boards published to Home ("Idee einreichen"). The backend
 * (`/me/idea-forms`) owns the rule: company-wide, home_listed ideas boards
 * INCLUDING the user's own workspace (unlike request-forms).
 */
export function useIdeaTargets() {
  return useQuery<RequestForm[]>({
    queryKey: ["me", "idea-forms"],
    queryFn: () => api.listIdeaForms(),
  });
}
